import fc from '@/firebaseConfig'
const _ = require('lodash');

export default {
  namespaced: true,
  state: {
    loading: false,
    listKey: [],
    mCerListUnsubscribeObject: null,
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val
    },
    setKeys(state, val) {
      state.listKey = val
    },
  },
  actions: {
    create({commit}, {companyId, keyData}) {
      commit('setLoading', true)
      let body = {
        libraryName: keyData.name,
        name: keyData.libraryName,
        libraryPath: keyData.libraryPath,
        passwordEncrypted: keyData.passwordEncrypted,
        type: keyData.type,
        timeUpdated: keyData.timeUpdated,
        timeCreated: new Date(),
      }
      fc.companies.doc(companyId).collection('Keys').add(body)
        .then(function () {
          commit('setLoading', false)
        })
        .catch(function (error) {
          console.log("error", error)
        })
    },
    getList({commit}, {companyId}) {
      if (this.state.mCerListUnsubscribeObject) { this.state.mCerListUnsubscribeObject() }
      this.state.mCerListUnsubscribeObject = fc.companies.doc(companyId).collection('Cers').onSnapshot((keys) => {
        let keysArray = []
        keys.forEach(async (key) => {
          let keyTmp = key.data()
          keyTmp.id = key.id
          if(keyTmp.nameIssuer){
            let nameIssuer = keyTmp.nameIssuer.split(", ")
            for (let i = 0; i < nameIssuer.length; i++) {
              let dataValue = _.cloneDeep(nameIssuer[i])
              nameIssuer[i] = dataValue.split("=")
            }
            keyTmp.nameIssuer = Object.fromEntries(nameIssuer)
          }

          if(keyTmp.nameSubject){
            let nameSubject = keyTmp.nameSubject.split(", ")
            for (let i = 0; i < nameSubject.length; i++) {
              let dataValue = _.cloneDeep(nameSubject[i])
              nameSubject[i] = dataValue.split("=")
            }
            keyTmp.nameSubject = Object.fromEntries(nameSubject)
          }

          keysArray.push(keyTmp)
        })
        commit('setKeys', keysArray)
      })
    },
    getCerListUnsubscribe() {
      if (this.state.mCerListUnsubscribeObject) {
        this.state.mCerListUnsubscribeObject()
        this.state.mCerListUnsubscribeObject = null
      }
    },
    deleteKey(context, {companyId, KeyId}) {
      fc.companies.doc(companyId).collection('Keys').doc(KeyId).delete()
        .then()
        .catch((error) => console.log("error", error))
    },
  }
  ,
}
